import styled from 'styled-components';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { AVATAR_SIZE, MENU_TRIGGER_SIZE, POST_GRID_CARD_FOOTER_HEIGHT } from './constants';

export const PostsNumber = styled(Typography)
    .withConfig({ displayName: 'PostsNumber' })
    .attrs((props) => ({
        ...props,
        color: 'white',
        variant: 'caption',
        position: 'absolute',
        lines: 1,
        backgroundColor: 'rgba(0, 0, 0, .24)',
        borderRadius: 1,
        m: 1,
        px: 0.75,
        py: 0.5,
    }))`
    -webkit-backdrop-filter: blur(25px);
    backdrop-filter: blur(25px);

    &&& {
        top: 0;
        right: 0;
        left: unset;
        transform: unset;
        width: unset;
        height: unset;
    }
`;

export const CollectionBadgesWrapper = styled(Flex)
    .withConfig({ displayName: 'CollectionBadgesWrapper' })
    .attrs((props) => ({
        ...props,
        direction: 'column',
        spacing: 0.25,
        position: 'absolute',
        width: '100%',
        m: 1,
    }))`
    &&& {
        top: unset;
        right: unset;
        transform: unset;
        left: 0;
        bottom: 0;
        width: 100%;
        height: unset;
    }
`;

export const Title = styled(Typography)
    .withConfig({ displayName: 'Title' })
    .attrs((props) => ({
        ...props,
        color: 'white',
        variant: 'title3',
        weight: 'heavy',
        lines: 2,
        backgroundColor: 'rgba(0, 0, 0, .24)',
        borderRadius: 1,
        px: 0.75,
        py: 0.5,

        maxWidth: 'calc(100% - 16px)',
    }))`
    -webkit-backdrop-filter: blur(25px);
    backdrop-filter: blur(25px);
    overflow-wrap: break-word;
`;

export const IconWrapper = styled(Box)
    .withConfig({ displayName: 'IconWrapper' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        borderRadius: 1,
        background: props.background || 'rgba(0, 0, 0, 0.24)',
    }))``;

export const CardFooter = styled(Flex)
    .withConfig({ displayName: 'CardFooter' })
    .attrs((props) => ({
        ...props,
        py: 0.75,
        px: 0.5,
        width: '100%',
        alignItems: 'center',
        height: POST_GRID_CARD_FOOTER_HEIGHT,
        position: 'relative',
    }))`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const BusinessName = styled(Typography)
    .withConfig({ displayName: 'BusinessName' })
    .attrs((props) => ({
        ...props,
        variant: 'caption',
        maxWidth: `calc(100% - ${AVATAR_SIZE + MENU_TRIGGER_SIZE}px)`,
        overflow: 'hidden',
        weight: 'medium',
    }))`
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const RelativeContainer = styled(Box)
    .withConfig({ displayName: 'RelativeContainer' })
    .attrs((props) => ({
        ...props,
        position: 'relative',
    }))``;
